// assets/care-guide-global.js
(function () {
  'use strict';

  function initCareGuideSystem() {
    // Check if any care guide sections exist on the page
    const careGuideElements = document.querySelectorAll(
      '[data-care-guide-section]',
    );

    // Exit early if no care guide sections found
    if (careGuideElements.length === 0) {
      return;
    }

    const allCareGuideData = [];

    // Merge data from all sections
    careGuideElements.forEach((element) => {
      try {
        const sectionData = JSON.parse(
          element.getAttribute('data-care-guide-data'),
        );
        allCareGuideData.push(...sectionData);
      } catch (error) {
        console.warn('Failed to parse care guide data:', error);
      }
    });

    // Render function
    function renderCareGuideContent() {
      const attribute = 'data-care-refs';
      const targetElements = document.querySelectorAll(`[${attribute}]`);

      // Exit early if no elements need care guide data
      if (targetElements.length === 0) {
        return;
      }

      const template = `
          {{#data}}
            <div>{{{ content }}}</div>
          {{/data}}
        `;

      targetElements.forEach((el) => {
        const refs = el
          .getAttribute(attribute)
          .split(',')
          .map((item) => item.trim().toLowerCase());
        const itemData = allCareGuideData.filter((item) =>
          refs.includes(item['ref'].trim().toLowerCase()),
        );
        el.innerHTML = Mustache.render(template, {data: itemData});
      });
    }

    // Execute immediately - all data is already available
    renderCareGuideContent();
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCareGuideSystem);
  } else {
    initCareGuideSystem();
  }

  window.initCareGuideSystem = initCareGuideSystem
})();
